import React, { useEffect, useState } from "react";
import { FormControlLabel, RadioGroup, Radio } from "@mui/material";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp,
  FaExchangeAlt,
  FaStickyNote,
  FaGlobe,
  FaCity,
  FaMapMarkerAlt,
  FaBuilding,
  FaLocationArrow,
  FaTruck,
  FaUserTie,
} from "react-icons/fa";
import axios from "axios";

const DetailsTab = ({ onDetailsChange, accountNoEdit, selectedAccountNo }) => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  console.log("🚀 ~ DetailsTab ~ selectedAccountNo:", selectedAccountNo);
  console.log("🚀 ~ DetailsTab ~ accountNoEdit:", accountNoEdit);
  // --- All form fields in one object ---
  const [form, setForm] = useState({
    primaryTel: "",
    alternatePhone: "",
    email: "",
    trn: "",
    streetAddress: "",
    address2: "",
    whatsappLocation: "",
    area: "",
    buildingType: "Villa", // default radio
    // buildingType: "", // default radio
    country: "",
    city: "",
    whatsapp: false,
    transactions: false,
    useTrnForAll: false,
    deliveryCollection: false,
    note: "",
    salesman: "",
  });

  const [areaList, setAreaList] = useState([]);
  const [detailsData, setDetailsData] = useState(null);
  const [salesmanList, setSalesmanList] = useState([]);
  const [selectedSalesman, setSelectedSalesman] = useState(null);

  // --- Fetch area list & sample data ---
  useEffect(() => {
    fetchAreaList();
    fetchSalesmanList();
    // fetchDetailsDataList();
  }, []);

  useEffect(() => {
    if (accountNoEdit?.length > 0) {
      fetchDetailsData();
    }
  }, [accountNoEdit]);

  useEffect(() => {
    if (selectedAccountNo?.length > 0) {
      fetchDetailsDataList(selectedAccountNo);
    }
  }, [selectedAccountNo]);

  const fetchAreaList = async () => {
    const COMPANY_CODE = localStorage.getItem("companyCode");
    const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    const apiURL = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/AREALIST/-/-`;
    try {
      const { data } = await axios.get(apiURL);
      setAreaList(data || []);
    } catch (err) {
      console.error("Error fetching area list", err);
    }
  };

  const fetchDetailsData = async () => {
    const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    const apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMGLSettings/${COMPANY_CODE}/ACCOUNTINFO/-/-/-/${accountNoEdit}`;
    try {
      const { data } = await axios.get(apiURL);
      // setDetailsData(data[0]);
      // // Pre-fill primary tel if available
      // if (data[0]?.phone) {
      //   updateField("primaryTel", data[0].phone);
      // }

      if (data && data.length > 0) {
        const fetched = data[0];
        setDetailsData(fetched);
        console.log("fetched edit data in customer:", fetched);
        console.log(
          "fetched edit data salesman in customer:",
          fetched.sale_man,
        );
        // Directly set the form data here
        setForm((prev) => ({
          ...prev,
          primaryTel: fetched.phone || "",
          email: fetched.email || "",
          creditMethod: fetched.CREDITMETHOD || "",
        }));
        // setSelectedSalesman(fetched.sale_man);
      }
    } catch (err) {
      console.error("Error fetching details data", err);
    }
  };

  useEffect(() => {
    if (detailsData?.sale_man && salesmanList.length > 0) {
      const matchedSalesman = salesmanList.find(
        (s) => s.EMP_ID === detailsData.sale_man
      );
      setSelectedSalesman(matchedSalesman || null);
      if (matchedSalesman) {
        setForm((prev) => ({ ...prev, salesman: matchedSalesman }));
      }
    }
  }, [detailsData, salesmanList]);

  const fetchDetailsDataList = async (selectedAccountNo) => {
    const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    const apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMGLSettings/${COMPANY_CODE}/ACCOUNTINFO/-/-/-/${selectedAccountNo}`;

    try {
      const { data } = await axios.get(apiURL);
      // setDetailsData(data[0]);
      // // Pre-fill primary tel if available
      // if (data[0]?.phone) {
      //   updateField("primaryTel", data[0].phone);
      // }

      if (data && data.length > 0) {
        const fetched = data[0];
        setDetailsData(fetched);

        // Directly set the form data here
        setForm((prev) => ({
          ...prev,
          primaryTel: fetched.phone || "",
          alternatePhone: fetched.msg || "",
          email: fetched.email || "",
          whatsapp: fetched.PriWhatsapp || "",
          useTrnForAll: fetched.InvStat || "",
          deliveryCollection: fetched.QtnStat || "",
          transactions: fetched.RetnStat || "",
          streetAddress: fetched.address3 || "",
          address2: fetched.address2 || "",
          whatsappLocation: fetched.GPSCorditate || "",
          area: fetched.area_code || "",
          buildingType: fetched.area_code || "",
          country: fetched.country || "",
          city: fetched.hide || "",
          note: fetched.dumpfield || "",
          // selectedSalesman: fetched.sale_man || "",
          creditMethod: fetched.CREDITMETHOD || "",
        }));
        setSelectedSalesman(fetched.sale_man || "");
      }
    } catch (err) {
      console.error("Error fetching details data", err);
    }
  };

  const fetchSalesmanList = async () => {
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";
    // const url = ${BASE_URL}/api/MasterCount/${COMPANY_CODE}/SALESPERSONLIST/-/${DEPARTMENT_NO};
    const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentSelectedDepartment}`;
    try {
      const response = await axios.get(url);
      console.log("salesmanList Response data:", response.data);
      setSalesmanList(response.data || []);
    } catch (err) {
      console.error("Error while loading salesman List data:", err);
      setSalesmanList([]);
    }
  };

  useEffect(() => {
    if (onDetailsChange) {
      onDetailsChange(form);
    }
  }, [form, onDetailsChange]);

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  // useEffect(() => {
  //   if (data?.sale_man && Array.isArray(salesmanList)) {
  //     const matchedSalesman = salesmanList.find(
  //       (s) => s.EMP_ID === data.sale_man
  //     );
  //     setSelectedSalesman(matchedSalesman || null);
  //   }
  // }, [data?.sale_man, salesmanList]);

  return (
    <div className="grid grid-cols-2 gap-6 bg-white p-4 rounded-lg shadow-md">
      {/* LEFT SIDE */}
      <div>
        <div className="mb-4">
          <h2 className="text-lg font-semibold text-gray-700 ">
            Personal Details
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-2">
          <div>
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaPhoneAlt className="mr-2 text-gray-600" /> Primary Tel
            </label>
            <input
              value={form.primaryTel}
              onChange={(e) => updateField("primaryTel", e.target.value)}
              placeholder="Enter Primary Tel Here..."
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaPhoneAlt className="mr-2 text-gray-600" /> Alternate Phone
            </label>
            <input
              value={form.alternatePhone}
              onChange={(e) => updateField("alternatePhone", e.target.value)}
              placeholder="Enter Alternate Phone Here..."
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>
          <div className="">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaEnvelope className="mr-2 text-gray-600" /> Email
            </label>
            <input
              value={form.email}
              onChange={(e) => updateField("email", e.target.value)}
              placeholder="Enter Email Here..."
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 flex items-center gap-1">
              <FaUserTie className="w-4 h-4 text-gray-600" />
              Salesman
            </label>
            <select
              name="salesman"
              value={selectedSalesman?.EMP_ID || ""}
              onChange={(e) => {
                const selected = salesmanList.find(
                  (s) => s.EMP_ID === e.target.value,
                );
                console.log("🚀 ~ DetailsTab ~ selected:", selected);
                setSelectedSalesman(selected);
                updateField("salesman", selected);
              }}
              className="w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            >
              <option className="" value="">
                {" "}
                --Select Salesman--{" "}
              </option>
              {Array.isArray(salesmanList) &&
                salesmanList.map((salesMan) => (
                  <option key={salesMan.EMP_ID} value={salesMan.EMP_ID}>
                    {salesMan.NAME}
                  </option>
                ))}
            </select>
          </div>

          {/* <div>
            <label className="block text-sm font-medium mb-1 flex items-center gap-1">
              <FaUserTie className="w-4 h-4 text-gray-600" />
              Salesman
            </label>
            <select
              name="salesman"
              value={selectedSalesman?.EMP_ID || ""}
              onChange={(e) => {
                const selected = salesmanList.find(
                  (s) => s.EMP_ID === e.target.value
                );
                setSelectedSalesman(selected);
                updateField("salesman", selected);
              }}
              className="w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            >
              <option value="">--Select Salesman--</option>
              {Array.isArray(salesmanList) &&
                salesmanList.map((salesMan) => (
                  <option key={salesMan.EMP_ID} value={salesMan.EMP_ID}>
                    {salesMan.NAME}
                  </option>
                ))}
            </select>
          </div> */}
          {/* <div>
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaHashtag className="mr-2 text-gray-600" /> TRN
            </label>
            <input
              value={form.trn}
              onChange={(e) => updateField("trn", e.target.value)}
              placeholder="Enter TRN# Here..."
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div> */}
        </div>

        {/* CHECKBOXES */}
        <div className="flex justify-between items-center my-6 flex-wrap gap-2">
          <label className="flex items-center cursor-pointer select-none">
            <input
              type="checkbox"
              checked={form.whatsapp}
              onChange={(e) => updateField("whatsapp", e.target.checked)}
              className="w-5 h-5 mr-2 rounded-md border-gray-400"
            />
            <FaWhatsapp className="mr-2 text-gray-600" />
            <span className="text-gray-700 text-sm font-semibold">
              Whatsapp
            </span>
          </label>

          <label className="flex items-center cursor-pointer select-none">
            <input
              type="checkbox"
              checked={form.transactions}
              onChange={(e) => updateField("transactions", e.target.checked)}
              className="w-5 h-5 mr-2 rounded-md border-gray-400"
            />
            <FaExchangeAlt className="mr-2 text-gray-600" />
            <span className="text-gray-700 text-sm font-semibold">
              Transactions
            </span>
          </label>

          <label className="flex items-center cursor-pointer select-none">
            <input
              type="checkbox"
              checked={form.useTrnForAll}
              onChange={(e) => updateField("useTrnForAll", e.target.checked)}
              className="w-5 h-5 mr-2 rounded-md border-gray-400"
            />
            <span className="text-gray-700 text-sm font-semibold">
              Use this TRN for all invoices
            </span>
          </label>

          <label className="flex items-center cursor-pointer select-none">
            <input
              type="checkbox"
              checked={form.deliveryCollection}
              onChange={(e) =>
                updateField("deliveryCollection", e.target.checked)
              }
              className="w-5 h-5 mr-2 rounded-md border-gray-400"
            />
            <FaTruck className="mr-2 text-gray-600" />
            <span className="text-gray-700 text-sm font-semibold">
              Delivery/Collection
            </span>
          </label>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 flex items-center">
            <FaStickyNote className="mr-2 text-gray-600" /> Note
          </label>
          <textarea
            value={form.note}
            onChange={(e) => updateField("note", e.target.value)}
            placeholder="Type any note about this customer"
            className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            rows={2}
          />
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div>
        <div className="grid grid-cols-2 gap-2 mt-11">
          <div className="">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaMapMarkerAlt className="mr-2 text-gray-600" /> Street Address
            </label>
            <input
              value={form.streetAddress}
              onChange={(e) => updateField("streetAddress", e.target.value)}
              placeholder="Enter Street Address Here..."
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaMapMarkerAlt className="mr-2 text-gray-600" /> Address 2
            </label>
            <input
              value={form.address2}
              onChange={(e) => updateField("address2", e.target.value)}
              placeholder="Enter Address 2 Here..."
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaLocationArrow className="mr-2 text-gray-600" /> GPS Location
            </label>
            <input
              value={form.whatsappLocation}
              onChange={(e) => updateField("whatsappLocation", e.target.value)}
              placeholder="Enter GPS Location Here..."
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaMapMarkerAlt className="mr-2 text-gray-600" /> Area
            </label>
            <select
              value={form.area}
              onChange={(e) => updateField("area", e.target.value)}
              className="w-full px-1 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            >
              <option value="">-- Select Area --</option>
              {areaList.map((ar) => (
                <option key={ar.ACODE_KEY} value={ar.ACODE_KEY}>
                  {ar.acode_name} - {ar.ACODE_KEY}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* BUILDING TYPE RADIO */}
        <RadioGroup
          row
          value={form.buildingType}
          onChange={(e) => updateField("buildingType", e.target.value)}
          className="my-4 flex justify-start items-center gap-4"
        >
          <FormControlLabel
            value="Apartment"
            control={<Radio />}
            label={
              <span className="flex items-center">
                <FaBuilding className="mr-2 text-gray-600" /> Apartment
              </span>
            }
          />
          <FormControlLabel
            value="Villa"
            control={<Radio />}
            label={
              <span className="flex items-center">
                <FaBuilding className="mr-2 text-gray-600" /> Villa
              </span>
            }
          />
          <FormControlLabel
            value="Warehouse"
            control={<Radio />}
            label={
              <span className="flex items-center">
                <FaBuilding className="mr-2 text-gray-600" /> Warehouse
              </span>
            }
          />
          <FormControlLabel
            value="Office"
            control={<Radio />}
            label={
              <span className="flex items-center">
                <FaBuilding className="mr-2 text-gray-600" /> Office
              </span>
            }
          />
        </RadioGroup>

        {/* COUNTRY & CITY */}
        <div className="w-full flex gap-3 justify-between items-center">
          <div className="w-full">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaGlobe className="mr-2 text-gray-600" /> Country
            </label>
            <select
              value={form.country}
              onChange={(e) => updateField("country", e.target.value)}
              className="w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            >
              <option value="">--Select Country--</option>
              <option value="UAE">UAE</option>
              <option value="Oman">Oman</option>
              <option value="Saudi">Saudi</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Qatar">Qatar</option>
            </select>
          </div>

          <div className="w-full">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaCity className="mr-2 text-gray-600" /> City/Town
            </label>
            {form.country === "UAE" ? (
              <select
                value={form.city}
                onChange={(e) => updateField("city", e.target.value)}
                className="w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
              >
                <option value="">--Select an Emirate--</option>
                <option value="Abu Dhabi">Abu Dhabi</option>
                <option value="Dubai">Dubai</option>
                <option value="Sharjah">Sharjah</option>
                <option value="Ajman">Ajman</option>
                <option value="Umm Al Quwain">Umm Al Quwain</option>
                <option value="Ras Al Khaimah">Ras Al Khaimah</option>
                <option value="Fujairah">Fujairah</option>
              </select>
            ) : (
              <input
                value={form.city}
                onChange={(e) => updateField("city", e.target.value)}
                placeholder="Enter City/Town Here..."
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
